<!-- 电话号码输入框 -->
<template>
  <div class="form_phone_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name"
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <div
      v-if="option.hasDescription && layout === 'vertical'"
      class="form_item_desc"
    >
      {{ option.description }}
    </div>
    <van-cell-group class="form_phone_num_wrap">
      <div
        v-if="layout === 'horizontal'"
        class="van-cell__title van-field__label form_phone_name"
        :class="option.isRequire ? 'form_item_horizontal_isNeed' : ''"
      >{{ option.label }}</div>
      <!-- 普通输入框 -->
      <!-- van-hairline--right -->
      <van-field
        class="form_phone_code "
        :readonly="option.cannotEdit"
        :placeholder="$t('book.form.countrycode')"
        v-model="country.value"
        type="number"
        :name="country.name"
        @input="inputCodeChange"
        :rules="[{ required: option.isRequire, message: country.label }]"
      />
      <van-field
        class="form_phone_number"
        v-model="option.value"
        type="number"
        :readonly="option.cannotEdit"
        :name="option.name"
        :error="error"
        :error-message="errorMessage"
        :placeholder="option.placeholder"
        :rules="[
          {
            validator: asyncValidator,
            message: $t('book.validator.require')
          }
        ]"
      />
    </van-cell-group>

    <!-- 手机验证码 -->
    <van-field
      v-if="option.isSendVerifyCode"
      v-model="verifyCode"
      type="number"
      center
      clearable
      :label="$t('book.form.label')"
      class="phone_code_wrap"
      :placeholder="$t('book.form.placeholder')"
    >
      <template #button>
        <van-button
          size="small"
          class="phone_code_btn"
          native-type="button"
          :disabled="timeIn"
          @click="handleSendCode"
          :style="{
            backgroundColor: `${btnSty.bg_color}`,
            borderColor: `${btnSty.bg_color}`,
            color: `${btnSty.color}`,
          }"
        >
          <span
            class="phone_code_text"
            :style="{
              color: `${btnSty.color}`,
            }"
            v-show="!timeIn"
          >{{$t('book.form.send')}}</span>
          <van-count-down
            v-show="timeIn"
            ref="countDown"
            :time="120000"
            :auto-start="false"
            :format="$t('book.form.format')"
            @finish="finish"
          />
        </van-button>
      </template>
    </van-field>
  </div>
</template>

<script>
import { ResForSendVerifyCode } from '@a/js/api/public'
export default {
  name: 'FormPhone',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    country: {
      type: Object,
      default: () => { }
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
  },
  data() {
    return {
      show: false,
      countryCode: '86',
      error: false,
      errorMessage: '',
      timeIn: false,
      verifyCode: '',
      params: {},
      btnSty: {
        bg_color: "#0066ff",
        color: "#ffffff"
      }
    }
  },

  components: {},

  watch: {
    verifyCode(value) {
      this.$emit('listenVerifyCodeChange', value)
    }
  },

  methods: {
    asyncValidator(value) {
      return new Promise(resolve => {
        if (value.length > 0) {
          if (this.country.value === '86') {
            const phoneReg = /^1[3|4|5|6|7|8|9]\d{9}$/
            if (phoneReg.test(value)) {
              resolve(this.SetCheckSuccMsg())
            } else {
              resolve(this.SetCheckErrorMsg(this.$t('book.validator.phone')))
            }
          } else {
            const abroadPhone = /^[0-9]*$/
            if (abroadPhone.test(value)) {
              // let refStr = this.option.name
              // console.log(this.$refs[refStr])
              this.$emit('resetValidation', this.option.name)
              resolve(this.SetCheckSuccMsg())
            } else {
              resolve(this.SetCheckErrorMsg(this.$t('book.validator.phone')))
            }
          }
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('book.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    },
    // 国别区号值变化
    inputCodeChange() {
      this.asyncValidator(this.option.value)
    },
    // 点击发送验证码
    handleSendCode() {

      if (!(this.country.value.trim().length > 0)) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.countryCodeTip'),
        })
        return
      }

      if (!(this.option.value.length > 0)) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.phoneTip'),
        })
        return
      } else if (this.error) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.phoneErr'),
        })
        return
      } else if (!this.error && this.option.value.length > 0) {

        this.SendVerifyCode()
      }

    },
    // 发送验证码
    SendVerifyCode() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        mobile_phone: this.option.value,
        country_code: this.country.value
      }
      ResForSendVerifyCode(data).then(() => {
        this.$notify({
          type: 'success',
          message: this.$t('notify.sendSms'),
        })
        this.$refs.countDown.start()
        this.timeIn = true
      }).catch(() => { })
    },
    finish() {
      this.timeIn = false
      this.$refs.countDown.reset();
    },
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 初始化按钮配置
    initBtnOpt() {
      let opt = this.$storeLocal.get('form_btn_sty')
      if (opt) {
        this.btnSty = opt
      }
    },
  },

  mounted() {
    this.GetParamsData().then(() => {
      this.initBtnOpt()
    })
  }
}
</script>
<style lang="less" scoped>
.form_phone_wrap {
  .form_phone_num_wrap {
    display: flex;
    padding-left: 16px;
    font-size: 0.37333rem;
    .form_phone_name {
      padding: 10px 0;
      line-height: 24px;
    }
    .form_phone_code {
      width: 70px;
      box-sizing: border-box;
      padding: 10px;
      padding-left: 0;
      // border-right: 1px solid #ebedf0;
      &::after {
        border-bottom: 0px !important;
      }

      :v-deep input {
        text-align: center !important;
      }
    }
    // .form_phone_code.van-cell.van-hairline--right::after {
    //   bottom: -50% !important;
    //   left: auto !important;
    //   border-bottom: 0 !important;
    // }
    .form_phone_number {
      flex: 1;
    }
  }
}
.phone_code_wrap {
  :v-deep .van-count-down {
    color: #fff;
  }
  // .phone_code_btn {
  //   background-color: var(--background);
  //   border-color: var(--background);
  //   color: var(--fontColor);
  //   .phone_code_text {
  //     color: var(--fontColor);
  //   }
  // }
}
</style>
